import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const OrderGetList = createAsyncThunk(
  "OrderGetList",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          url: API_URL.BASEURL + API_URL?.ORDER?.GET_LIST,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const OrderSave = createAsyncThunk(
  "OrderSave",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL?.ORDER?.SAVE,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const OrderByPrimaryKey = createAsyncThunk(
  "OrderByPrimaryKey",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL?.ORDER?.GET_BY_PRIMARY_KEY,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

const initialState = {
  OrderGetListData: {
    data: null,
    error: null,
  },
  OrderSaveData: {
    data: null,
    error: null,
  },
  OrderByPrimaryKeyData: { data: null, error: null },
};

const OrderSlice = createSlice({
  name: "ORDER",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(OrderGetList.fulfilled, (state, action) => {
        state.OrderGetListData.data = action.payload;
      })
      .addCase(OrderGetList.rejected, (state, action) => {
        state.OrderGetListData.error = action.error.message;
      })
      .addCase(OrderSave.fulfilled, (state, action) => {
        state.OrderSaveData.data = action.payload;
      })
      .addCase(OrderSave.rejected, (state, action) => {
        state.OrderSaveData.error = action.error.message;
      })
      .addCase(OrderByPrimaryKey.fulfilled, (state, action) => {
        state.OrderByPrimaryKeyData.data = action.payload;
      })
      .addCase(OrderByPrimaryKey.rejected, (state, action) => {
        state.OrderByPrimaryKeyData.error = action.error.message;
      });
  },
});

export default OrderSlice.reducer;
